module.exports = __webpack_public_path__ + "img/$pac.c830fed4.svg";